(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["jhift-product-content"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = window.matchMedia('(min-width: 990px)');
    const placements = new Map();
    let scheduled = false;

    function updateLayout() {
      scheduled = false;
      for (const [accordion, placement] of placements) {
        if (!accordion.isConnected || !placement.marker.isConnected) {
          if (accordion.isConnected && !placement.marker.isConnected) accordion.remove();
          placement.marker.remove();
          placements.delete(accordion);
        }
      }
      document.querySelectorAll('.product-information').forEach((section) => {
        if (!section.querySelector('variant-picker[data-jhift-size-gate="true"]')) return;
        const grid = section.querySelector('[data-product-grid-content]');
        const accordion = section.querySelector('.accordion:has(.jhift-product-content)');
        if (!grid || !accordion) return;
        let placement = placements.get(accordion);
        if (desktop.matches) {
          if (!placement) {
            const marker = document.createComment('JHIFT mobile information position');
            accordion.before(marker);
            placement = { marker };
            placements.set(accordion, placement);
          }
          accordion.classList.add('jhift-wide-information');
          if (accordion.parentElement !== grid) grid.append(accordion);
        } else if (placement) {
          placement.marker.before(accordion);
          accordion.classList.remove('jhift-wide-information');
          placement.marker.remove();
          placements.delete(accordion);
        }
      });
    }

    function scheduleLayout() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(updateLayout);
    }

    function start() {
      updateLayout();
      const observer = new MutationObserver((changes) => {
        const relevant = changes.some((change) => [...change.addedNodes].some((node) =>
          node instanceof Element && (
            node.matches('.product-information, .accordion, .jhift-product-content') ||
            node.querySelector('.product-information, .jhift-product-content')
          )
        ));
        if (relevant) scheduleLayout();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    desktop.addEventListener('change', scheduleLayout);
    document.addEventListener('shopify:section:load', scheduleLayout);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
